module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna11yrs-6@3x.jpg?ddc4ac93";